function throwConfettiWelcome() {
  (()=>{
      confetti({
          particleCount: 100,
          spread: 100,
          origin: { y: 0.6 }
      });
  })();
}

document.addEventListener("DOMContentLoaded", (event) => {
  const modalContainers = document.querySelectorAll('.dice__modal-container');
  modalContainers.forEach(element => {
    element.classList.add('popup-show');
  });
  let rollBtn = document.querySelector('.dice__content-wrapper .roll-btn');
  let btnLoadingAnimation = rollBtn.querySelector('.dice__content-wrapper #popup-form-btn-loader');
  let btnText = rollBtn.querySelector('.dice__content-wrapper #popup-form-btn-text');
  let diceContainer = document.querySelector('.dice__content-wrapper .dice-container');
  let dice = document.querySelector('.dice__content-wrapper .dice-container .dice');
  let rollMax = 8;
  let maxAttempts = Number(diceContainer.dataset.nthAttempt) || 3;

  let angleX = 0,
    angleY = 0,
    result = 1,
    delay = 0,
    canRoll = true,
    rollCount = 0;

  const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
  }

  const rollDice = () => {
    rollBtn.disabled = true;
    btnLoadingAnimation.style.display = "block";
    btnText.style.display = "none";
    canRoll = false;
    rollCount++;

    let xTurn, yTurn;
    if (rollCount > maxAttempts) {
      angleX = 0;
      angleY = 180;
    } else {
      xTurn = 4 + getRandomInt(rollMax);
      yTurn = 4 + getRandomInt(rollMax);

      delay = Math.max(xTurn, yTurn) * 100;

      angleX += 90 * xTurn;
      angleY += 90 * yTurn;

      if (angleX % 180) {
        getRandomInt(3) > 1 && (angleX += 90);
      }
    }

    dice.style.transform = "rotateX(" + angleX + "deg) rotateY(" + angleY + "deg)";
    dice.style.transitionDuration = delay + 'ms';

    let x = angleX % 360,
      y = angleY % 360;

    if (x === 0 || x === 180) {
      switch ((x + y) % 360) {
        case 0: result = 1; break;
        case 90: result = 5; break;
        case 180: result = 6; break;
        case 270: result = 2; break;
        default:
          console.error(123456);
      }
    } else if (x === 90) {
      result = 4;
    } else if (x === 270) {
      result = 3;
    }

    if (rollCount > maxAttempts && result !== 6) {
      result = 6;
      angleX = 0;
      angleY = 180;
      delay = 800;
      dice.style.transform = "rotateX(0deg) rotateY(180deg)";
      dice.style.transitionDuration = '800ms';
    }

    setTimeout(() => {
      canRoll = true;
      if (result === 6) {
        setTimeout(() => {
            const modalContainers = document.querySelectorAll('.dice__modal-container');
            modalContainers?.forEach(element => {
              element.classList.remove('popup-show');
            });
            throwConfettiWelcome();
        }, 1000);
      }else{
        setTimeout(() => {
          rollBtn?.classList.add('btn-danger');
          rollBtn.disabled = false;
          btnLoadingAnimation.style.display = "none";
          btnText.style.display = "block";
          btnText.textContent = "TRY AGAIN";
        }, 500);
      }
    }, delay);

    return result;
  }

  const handleKeyDown = (event) => {
    if (event.code === 'Space' && canRoll) {
      event.preventDefault()
      rollDice();
    }
  }

  document.addEventListener('keydown', handleKeyDown);
  rollBtn.addEventListener('click', () => canRoll && rollDice());
  diceContainer.addEventListener('click', () => canRoll && rollDice());

  const closeButtons = document.querySelectorAll('.dice__modal-content-holder .dice__popup-close');
  closeButtons?.forEach(button => {
    button.addEventListener('click', function() {
      const modalContainers = document.querySelectorAll('.dice__modal-container');
      modalContainers?.forEach(container => {
        container.classList.remove('popup-show');
      });
    });
  });

})
